import React from 'react';
import { OrderSelector } from './OrderSelector';
import { RadialSelector } from './RadialSelector';
import { DerivationFilterProps } from '../interfaces/DerivationProps';

export const DerivationFilter: React.FC<DerivationFilterProps> = ({
  selectedView,
  setSelectedView,
  sortOrder,
  setSortOrder,
}) => {
  return (
    <div className='flex flex-col gap-3 bg-gray-100 items-center justify-between rounded-xl p-3 w-full shadow-inner'>
      <div className='w-full'>
        <RadialSelector
          selectedView={selectedView}
          setSelectedView={setSelectedView}
        />
      </div>
      <div className='w-full'>
        <OrderSelector sortOrder={sortOrder} setSortOrder={setSortOrder} />
      </div>
    </div>
  );
};
